module.exports = __webpack_public_path__ + "img/LOGO.6d14ee13.png";